export type ProductSummary = Queries.DatoCmsProductSummaryFragment & {
  pim?: {
    name?: string | null;
  } | null;
};

export type ProductSummaryWithFinishGroups = ProductSummary & {
  finishGroups: Queries.FinishGroupFragment[];
};

export type ProductBundleSummary = ProductSummary & {
  bundleOptions: BundleOption[] | null;
};

export type ConfigurableProduct = {
  sku: string;
  name: string;
  label: string;
  isDefault: boolean;
  finishGroups: (Queries.AkeneoFinishGroup | null)[];
  position: number;
  canChangeQuantity: boolean;
  image?: string;
  pim: Queries.AkeneoProductFragment;
};

export enum VariationView {
  Image = 'image',
  ImageFinish = 'image_finish',
  Material = 'material',
  MaterialDimensions = 'material_dimensions',
  SeatBackCushion = 'seat_back_cushion',
  None = 'none',
  Normal = 'normal',
}

type ArrayOfFixedLength<T> = [c1: T, c2: T, c3: T, c4: T];

export type ConfigurableProductCharacteristic = {
  title: string;
  view: VariationView;
};

export type ConfigurableProductCharacteristics =
  ArrayOfFixedLength<ConfigurableProductCharacteristic>;

export type BundleOption = {
  products: ConfigurableProduct[];
  isRequired: boolean;
  sku: string;
  title: string;
  position: number;
  characteristics: ConfigurableProductCharacteristic[];
};

export type ConfiguredProductCharacteristic = string | null;
export type ConfiguredProductCharacteristics =
  ArrayOfFixedLength<ConfiguredProductCharacteristic>;

export type ConfiguredProduct = {
  sku: string;
  quantity: number;
  characteristics: ConfiguredProductCharacteristics;
};

export type ConfiguredBundleOption = ConfiguredProduct | null;

export type ConfiguredProductBundle = {
  sku: string;
  quantity: number;
  options: ConfiguredBundleOption[];
};

export type WishlistItem = ConfiguredProduct | ConfiguredProductBundle;

export type SerializedConfiguredProduct = string;
export type SerializedConfiguredProductBundle = [string, SerializedConfiguredProduct[]];
